const BASE = process.env.ENV === 'preview' ? 'api/gp-gateway-staging/' : 'api/gp-gateway/'
const urls = {
  // 获取谷粒充值列表
  allCoinProduct: 'get api/v1/order/product/service/allCoinProduct',
  // 充值
  wechatPay: 'post api/v1/order/recharge/service/createFromH5'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS



// WEBPACK FOOTER //
// ./src/apis/api-urls/gp-gateway.js